import React from 'react';
import FantasyMindIcon from './FantasyMindIcon';

interface FantasyMindLogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  className?: string;
}

const FantasyMindLogo: React.FC<FantasyMindLogoProps> = ({ 
  size = 'medium',
  showText = true,
  className = ''
}) => {
  const iconSizes = {
    small: 24,
    medium: 32,
    large: 40
  };

  const textSizes = {
    small: 'text-xl',
    medium: 'text-2xl',
    large: 'text-3xl'
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <FantasyMindIcon size={iconSizes[size]} className="text-[#0c77f2]" />
      {showText && (
        <div className={`font-['Manrope'] font-extrabold text-[#f0f4f8] ${textSizes[size]}`} style={{ fontFamily: 'Manrope', fontWeight: 800 }}>
          Fantasy Mind
        </div>
      )}
    </div>
  );
};

export default FantasyMindLogo;